import { render, staticRenderFns } from "./TheBurgerMenu.vue?vue&type=template&id=59050815&scoped=true"
import script from "./TheBurgerMenu.vue?vue&type=script&lang=ts"
export * from "./TheBurgerMenu.vue?vue&type=script&lang=ts"
import style0 from "./TheBurgerMenu.vue?vue&type=style&index=0&id=59050815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59050815",
  null
  
)

export default component.exports